import * as fp from 'lodash/fp';

import { CartItem } from '~/types/cart';

export default function calcItemTotal(item: CartItem): number {
  const optionsTotal = fp.pipe(
    fp.flatMap(fp.prop('options')),
    fp.sumBy(fp.prop('price')),
  )(item.modifiers);

  return item.count * (item.price + optionsTotal);
}
